import CURRENCIES from "../../config/currencies";
import { defaultCurrency, type Currency } from "../../config/currencies";

interface ICurrency {
  amount: number, // The amount in smallest unit (cent, kobo, etc)
  currencyCode?: string, // 3-letter currency code
  compact?: boolean,
}

interface FormatOptions { 
  locale: string; 
  notation: "compact" | "standard"; 
}

export default function PriceDisplay({ amount, currencyCode, compact }: ICurrency) {
  let currency: Currency | undefined = Object.values(CURRENCIES).find(curr => curr.code === currencyCode);

  if(!currency) {
    currency = defaultCurrency;
  }

  return formatAmountForDisplay(amount, currency!.code, {
    locale: currency!.locale,
    notation: compact ? "compact" : "standard",
  });
}

function formatAmountForDisplay(amount: number, currencyCode: string, options: FormatOptions) {
  const { locale, notation } = options;

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currencyDisplay: "narrowSymbol",
    currency: currencyCode,
    notation: notation,
  });

  return formatter.format(amount / 100);
}
